import React from 'react';
import { getProviderContactPhone } from '@kyruus/provider-components';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ExtendedProvider } from 'Src/types';
import { CtaListItem, ListItemButtonProps } from './CtaListItem';
import { PhoneNumber } from '../../styles';
import { messages, DefaultCtaListItems } from '../../lib';

interface BasePhoneProps {
  provider: ExtendedProvider;
  trackListItemClick: (listItem: DefaultCtaListItems) => void;
}
type PhoneProps = BasePhoneProps & WrappedComponentProps;

export const Phone = injectIntl(
  ({ provider, intl, trackListItemClick }: PhoneProps) => {
    const providerPhone = getProviderContactPhone(provider) ?? '';
    const phoneLabel = intl.formatMessage(messages.phoneTitle);
    const primaryText = (
      <>
        {phoneLabel}
        <PhoneNumber>{providerPhone}</PhoneNumber>
      </>
    );
    const secondaryText =
      intl.formatMessage(messages.phoneSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.phoneSubtitle);
    const buttonProps: ListItemButtonProps = {
      component: 'a',
      href: `tel:${providerPhone}`,
      role: 'link',
      onClick: () => trackListItemClick(DefaultCtaListItems.Phone)
    };

    return (
      <CtaListItem
        buttonProps={buttonProps}
        isExternalLink={false}
        primaryText={primaryText}
        secondaryText={secondaryText}
      />
    );
  }
);
